/*

https://gist.github.com/its-florida/1290439

You can now create a spinner using any of the variants below:

$("#el").spin(); // Produces default Spinner using the text color of #el.
$("#el").spin("small"); // Produces a 'small' Spinner using the text color of #el.
$("#el").spin("large", "white"); // Produces a 'large' Spinner in white (or any valid CSS color).
$("#el").spin({ ... }); // Produces a Spinner using your custom settings.

$("#el").spin(false); // Kills the spinner.

*/
// Wait for thirdparty bundle to ensure Spinner is loaded
function initSpinPlugin() {
    if (typeof window.Spinner === 'undefined') {
        console.log('jquery.spin.js: Waiting for Spinner to be available...');
        setTimeout(initSpinPlugin, 50);
        return;
    }

    console.log('jquery.spin.js: Spinner available, initializing plugin');

    (function($) {
        $.fn.spin = function(opts, color) {
            var presets = {
                "tiny": { lines: 8, length: 2, width: 2, radius: 3 },
                "small": { lines: 8, length: 4, width: 3, radius: 5 },
                "large": { lines: 10, length: 8, width: 4, radius: 8 }
            };
            if (window.Spinner) {
                return this.each(function() {
                    var $this = $(this),
                        data = $this.data();

                    if (data.spinner) {
                        data.spinner.stop();
                        delete data.spinner;
                    }
                    if (opts !== false) {
                        if (typeof opts === "string") {
                            if (opts in presets) {
                                opts = presets[opts];
                            } else {
                                opts = {};
                            }
                            if (color) {
                                opts.color = color;
                            }
                        }
                        console.log('jquery.spin.js: Creating spinner with opts:', opts);
                        data.spinner = new window.Spinner($.extend({color: $this.css('color')}, opts)).spin(this);
                        console.log('jquery.spin.js: Spinner created:', data.spinner);
                    }
                });
            } else {
                console.error("Spinner class not available.");
                throw "Spinner class not available.";
            }
        };
    })(jQuery);
}

$(document).ready(function(){
    initSpinPlugin();
})
